<template>
  <v-card
    class="user-info-card"
    :class="{ 'is-withdrawn': userProfile.withdrawn }"
    flat
  >
    <div class="basic-info-title">
      基本情報
    </div>
    <p
      v-if="userProfile.possiblyDummy"
      class="dummy-notice"
    >
      ※セイ・メイ・郵便番号・電話番号がダミーの可能性があるユーザーです
    </p>
    <div class="user-info-grid">
      <div class="user-info-column">
        <div class="user-info-row">
          <span class="user-info-label">ユーザーID</span>
          <span class="user-info-value">{{ userId }}</span>
        </div>
        <div class="user-info-row">
          <span class="user-info-label">セイメイ</span>
          <span class="user-info-value">{{ displayName }}</span>
        </div>
      </div>
      <div class="user-info-column">
        <div class="user-info-row">
          <span class="user-info-label">性別</span>
          <span class="user-info-value">{{ userProfile.gender }}</span>
        </div>
        <div class="user-info-row">
          <span class="user-info-label">生年月日</span>
          <span class="user-info-value">{{ userBirthdayWithAge }}</span>
        </div>
      </div>
      <div class="user-info-column">
        <div class="user-info-row">
          <span class="user-info-label">最終出産日/出産予定日</span>
          <span class="user-info-value">{{ userProfile.deliveryDate }}</span>
        </div>
        <div class="user-info-row">
          <span class="user-info-label">郵便番号と市区町村</span>
          <span class="user-info-value">{{ formattedPostalCode }}</span>
        </div>
      </div>
      <div class="user-info-column">
        <div class="user-info-row">
          <span class="user-info-label">電話番号</span>
          <span class="user-info-value">{{ userProfile.phoneNumber }}</span>
        </div>
        <div class="user-info-row">
          <span class="user-info-label">メール</span>
          <span class="user-info-value">{{ userProfile.email }}</span>
        </div>
      </div>
      <div class="user-info-column">
        <div class="user-info-row">
          <span class="user-info-label">クーポン名</span>
          <span class="user-info-value coupon-name">
            {{ couponName }}<br>
            <span class="coupon-id">(ID: {{ userProfile.couponId }})</span>
          </span>
        </div>
        <div
          v-if="userProfile.level2FrequentUseControlLabel"
          class="user-info-row"
        >
          <span class="user-info-value level2-frequent-use-control">{{ userProfile.level2FrequentUseControlLabel }}</span>
        </div>
      </div>
    </div>

    <slot />
  </v-card>
</template>

<script>
export default {
  name: "FaceSheetUserInfoCard",
  props: {
    userId: {
      type: String,
      required: true
    },
    displayName: {
      type: String,
      required: true
    },
    userProfile: {
      type: Object,
      required: true
    },
    userBirthdayWithAge: {
      type: String,
      required: true
    },
    formattedPostalCode: {
      type: String,
      required: true
    },
    couponName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.user-info-card {
  width: 100%;
  padding: 16px 24px;
  background-color: #ffeef1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.user-info-card.is-withdrawn {
  background-color: #efefef;
}

.basic-info-title {
  margin-bottom: 8px;
  font-weight: bold;
}

.dummy-notice {
  margin: 0 0 8px;
  color: #d32f2f;
  font-size: 0.8rem;
  font-weight: 500;
}

.user-info-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
}

.user-info-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.user-info-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.user-info-label {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.8rem;
  white-space: nowrap;
}

.user-info-value {
  min-width: 0;
  font-size: 0.875rem;
  font-weight: 500;
  word-break: break-word;
}

.coupon-id {
  font-size: 0.75rem;
  font-weight: 400;
}

.level2-frequent-use-control {
  font-size: 0.8rem;
}
</style>
